/**
 * Ella Radio reserve tank — client-side track bank from continue reserveTracks responses.
 */

import type { SmartPlaylistTrack } from '../services/smartPlaylistService';

let _reserveTank: SmartPlaylistTrack[] = [];

export function resetReserveTank(): void {
  _reserveTank = [];
}

export function bankReserveTracks(tracks: SmartPlaylistTrack[] | undefined | null): void {
  if (!tracks?.length) return;
  _reserveTank.push(...tracks);
}

export function reserveTankSize(): number {
  return _reserveTank.length;
}

/** Pull up to `count` tracks from the reserve (FIFO). */
export function pullFromReserve(count = 8): SmartPlaylistTrack[] {
  if (_reserveTank.length === 0) return [];
  const n = Math.min(count, _reserveTank.length);
  return _reserveTank.splice(0, n);
}

export function mergeIntoReserve(tracks: SmartPlaylistTrack[] | undefined | null): void {
  bankReserveTracks(tracks);
}
